import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useState } from "react";
import { ContainerCardsCategories, ContainerCardsSizeProject, ContainerCardsSymbology } from "../../../components/container";
import { PieChartSizeProject } from "../../../components/Graphics/PieChartSizeProject";
import { SelectDateGeneral } from "../../../components/Select/SelectDateGeneral";
import { getAllProjectSize } from "../../../redux/slices/general/generalAction";
import { SunBurstProject } from "../../../components/Graphics/SunBurstProject";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { useGeneralData } from "../../../hooks/useGeneralData";
import LeaderTab from './LeaderTab'

export const General = () => {
    const {
        general: { projectCategories, projectSize, projectLeaders, datesCategories, datesSize },
    } = useSelector((state) => state);

    const { fetchData } = useGeneralData();

    const dispatch = useDispatch();
    const getAllSize = useCallback(() => {
        dispatch(getAllProjectSize());
    }, [dispatch]);
    useEffect(() => {
        getAllSize();
    }, [getAllSize]);
    const [selectedSection, setSelectedSection] = useState(0);

    const handleSectionChange = (index) => {
        setSelectedSection(index);
    };
    const sections = ["Tabla", "Gráfica"];

    const items = [
        {
            label: `Clasificación de Proyectos`,
            key: "2",
            children: (
                <CardDetailProject
                    title="Cantidad de Proyectos divididos operativamente por categoría."
                    titleClass="sm:w-[calc(100%-120px)]"
                    headerChildren={
                        <SelectDateGeneral
                            style={{ width: "100px" }}
                            placeholder="selecciona un año"
                            selectDateYear={datesCategories}
                            handleChange={(value) => fetchData.categories(value)}
                        />
                    }
                >
                    <section className="w-full mt-4 md:mt-8 flex flex-col xl:flex-row justify-center xl:justify-around items-center gap-6 md:gap-10 lg:gap-20">
                        <SunBurstProject />
                        <ContainerCardsCategories data={projectCategories.children} extraClass="max-w-[700px]" />
                    </section>
                </CardDetailProject>
            ),
        },
        {
            label: `Tamaño de Proyecto`,
            key: "3",
            children: (
                <CardDetailProject
                    title="Cantidad de Proyectos divididos operativamente por horas presupuestadas."
                    titleClass="sm:w-[calc(100%-120px)]"
                    headerChildren={
                        <SelectDateGeneral
                            style={{ width: "100px", marginBottom: "auto" }}
                            placeholder="selecciona un año"
                            selectDateYear={datesSize}
                            handleChange={(value) => fetchData.projectSize(value)}
                        />
                    }
                >
                    <section className="w-full mt-4 md:mt-8 flex flex-col justify-center place-items-center items-center md:grid xl:grid-cols-[1fr,_2fr] gap-4 md:[grid-template-areas:'graphic_points''cards_cards'] xl:[grid-template-areas:'graphic_points''graphic_cards']">
                        <PieChartSizeProject />
                        <div className="flex flex-col grow gap-4 xl:flex-row md:[grid-area:points] w-full max-w-[848px]">
                            <ContainerCardsSymbology
                                extraClass="grow"
                                title="Horas del proyecto"
                                data={projectSize}
                                labelName="label"
                                conditionalFilter={(label) => label === "E" || label === "F"}
                                customProp="label"
                            />
                            <ContainerCardsSymbology
                                extraClass=" xl:max-w-fit "
                                title="Otras categorías"
                                data={projectSize}
                                labelName="label"
                                conditionalFilter={(label) => !(label === "E" || label === "F")}
                                customProp="label"
                            />
                        </div>
                        <ContainerCardsSizeProject data={projectSize} extraClass="md:[grid-area:cards] xl:grid-cols-4  xl:max-w-[848px]" />
                    </section>
                </CardDetailProject>
            ),
        },
        {
            label: `Distribución de Líderes`,
            key: "4",
            children: (
                <LeaderTab
                    sections={sections}
                    handleSectionChange={handleSectionChange}
                    selectedSection={selectedSection}
                    projectSize={projectSize}
                    projectLeaders={projectLeaders}
                />
            ),
        },
    ];

    return (
        <div className="lg:p-12 p-4 w-full min-h-[calc(100vh-64px)]">
            <Tabs defaultActiveKey="1" style={{ height: "100%" }} items={items} />
        </div>
    );
};
